module.exports = __webpack_public_path__ + "static/media/sets_reps_infographic.6ddeab17.webp";